import { environment } from 'src/environments/environment';

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '@core/services';
import { ScannedResponse } from '@core/services/scanner/scanner.service';
import { ActionSheetController, AlertController, ModalController, PickerController, Platform } from '@ionic/angular';
import { ScanningModalComponent } from '@shared/components/scanning-modal/scanning-modal.component';
import { Campus, User } from '@shared/models';

import { ImageViewerComponent } from '../component/image-viewer/image-viewer/image-viewer.component';
import { TutorialComponent } from '../component/tutorial/tutorial.component';
import { RegisterSamlModalComponent } from '../login/components/register-saml-modal/register-saml-modal.component';
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';
import { DataService } from '../services/data.service';
import { HelpService } from '../services/help.service';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  user: User | null = null;
  version = 'v' + environment.version;
  downloadProgress = 0;
  period = '';
  isIos = false;

  constructor(
    private modalCtrl: ModalController,
    private platform: Platform,
    private actionSheetCtrl: ActionSheetController,
    private alertCtrl: AlertController,
    private dataService: DataService,
    private auth: AuthService,
    private pickerCtrl: PickerController,
    private router: Router,
    private storage: StorageService,
    private helpService: HelpService,
    private apiService: ApiService,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.calcPeriod();
    this.auth.getUser().then((user) => {
      this.user = user;
    });
  }

  calcPeriod() {
    const date = new Date();
    const month = date.getMonth();
    switch (true) {
      case 0 <= month && month < 5:
        this.period = 'Enero - Mayo ' + date.getFullYear();
        break;
      case 5 <= month && month < 7:
        this.period = 'Verano ' + date.getFullYear();
        break;
      default:
        this.period = 'Agosto - Diciembre ' + date.getFullYear();
        break;
    }
  }

  ionViewDidEnter() {
    this.auth.getUserFromServer().then((user) => {
      this.user = user;
    });
    if (this.platform.is('cordova')) {
      if (this.platform.is('ios')) {
        console.log('ios');
        this.isIos = true;
      }
    }
  }

  async showCampusPicker() {
    this.loadingService.present();
    const campuses = await this.apiService.getData('campus');
    this.loadingService.dismiss();
    const options = campuses.data?.map((campus: Campus) => {
      return { text: campus.name, value: campus.id };
    });
    if (!options) return;
    const picker = await this.pickerCtrl.create({
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Seleccionar',
          handler: (data) => {
            if (!this.user) {
              return;
            }
            if (this.user.campus_current !== data.campus.value) {
              this.auth.switchCampus(data.campus.value).then(async (user) => {
                this.user = await this.auth.getUserFromServer();
              });
            }
          },
        },
      ],
      columns: [
        {
          name: 'campus',
          options,
        },
      ],
    });
    picker.present();
  }

  async presentActionSheet() {
    if (!this.user) {
      return;
    }
    if (this.user.campus_current > 2) {
      const actionSheet = await this.actionSheetCtrl.create({
        header: 'Selecciona tutorial',
        buttons: [
          {
            text: 'Suscripción',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'transportec-suscripcion' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
          {
            text: 'Rutas y horarios',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'transportec-rutas' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
          {
            text: 'Compra de boletos',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'transportec-boletos' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
          {
            text: 'Recarga de saldo',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'transportec-saldo' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
          {
            text: 'Calificar servicio',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'transportec-calificar' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
          {
            text: 'Centro de ayuda',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'transportec-ayuda' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
        ],
      });
      actionSheet.present();
    } else {
      const actionSheet = await this.actionSheetCtrl.create({
        header: 'Selecciona tutorial',
        buttons: [
          {
            text: 'Meal plan',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'mealplan' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
          {
            text: 'ExpresoTec',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'expresotec' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
          {
            text: 'Calificar',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'calificar' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
          {
            text: 'Canjear',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'canjear' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
          {
            text: 'Cliente frecuente',
            handler: () => {
              this.modalCtrl
                .create({
                  component: TutorialComponent,
                  componentProps: { tutorial: 'clientefrecuente' },
                })
                .then((modal) => {
                  modal.present();
                });
            },
          },
          {
            text: 'Cancelar',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            },
          },
        ],
      });
      actionSheet.present();
    }
  }

  async logout() {
    const alert = await this.alertCtrl.create({
      header: 'Logout',
      message: '¿Esta seguro que quiere cerrar sesión?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Logout',
          handler: () => {
            console.log('Cerrar clicked');
            this.auth.singleLogOut();
          },
        },
      ],
    });
    alert.present();
  }

  goTabsBusiness() {
    // this.events.publish('user:business');
  }

  async goRegister() {
    const previewModal = await this.modalCtrl.create({
      component: 'RegisterPage',
      componentProps: { user: this.user },
    });
    previewModal.present();
  }

  async goTerms() {
    const openedModal = await this.modalCtrl.getTop();
    if (openedModal) {
      return;
    }

    const modal = await this.modalCtrl.create({
      component: RegisterSamlModalComponent,
      componentProps: { user: this.user, mode: 'read' },
    });
    modal.present();
  }

  goPrivacy() {
    this.goTerms();
  }

  goSettings() {
    if (!this.user) {
      return;
    }
    this.dataService.setData(this.user.id, this.user);
    if (this.router.url === '/tecservice-transportec/profile') {
      this.router.navigate(['/tecservice-transportec/profile/settings/', this.user.id]);
    } else {
      this.router.navigate(['/tecservice/profile/settings/', this.user.id]);
    }
  }

  async viewImage(src?: string, title: string = '', description: string = '') {
    if (!src) {
      return;
    }
    const modal = await this.modalCtrl.create({
      component: ImageViewerComponent,
      componentProps: {
        imgSource: src,
        imgTitle: title,
        imgDescription: description,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }

  error() {
    throw new Error('I am a bug...');
  }

  async help() {
    const data = await this.helpService.presentActionSheet();
    if (data?.action === 'scanQR') {
      this.buyTicketByQr();
    }
  }

  async buyTicketByQr(): Promise<void> {
    try {
      const modal = await this.modalCtrl.create({
        component: ScanningModalComponent,
      });
      await modal.present();
      const { data } = await modal.onWillDismiss<ScannedResponse>();
      if (!data) {
        return;
      }
      this.onScanned(data);
    } catch (error) {
      console.log('Error scanning', error);
    }
  }

  async onScanned(response: ScannedResponse): Promise<void> {
    if (!response || !response.code || !this.isSellCodeValid(response.code)) {
      this.wrongQr();
      return;
    }
    const codeArray = response.code.split('|');
    const realtripId = +codeArray[1];
    const stopId = +codeArray[2];
    const ticketInfo = await this.getTicketInfo({ realtripId, stopId });
    const paymentConfirmation = await this.presentConfirmationDialog(ticketInfo);
    (await paymentConfirmation) && this.payTicket({ realtripId, stopId, price: ticketInfo.price });
  }

  isSellCodeValid(code: string) {
    const codeArray = code.split('|');
    // Check if it is a ticket sell code
    if (codeArray.length !== 5 || codeArray[0] !== 'ticketsell') {
      return false;
    }

    // Check if the realtrip.id and current stop.id are valid
    if (isNaN(+codeArray[1]) || isNaN(+codeArray[2])) {
      return false;
    }

    // Check if the qr code is from now (5 min window)
    /*
    const scanDate = new Date(codeArray[3]);
    const now = new Date();
    if (Math.abs(differenceInMinutes(now, scanDate)) > 5) {
      return false;
    }*/
    return true;
  }

  async wrongQr(): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: 'Código QR incorrecto',
      message: 'Favor de verificar código o escanear nuevamente.',
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
        },
      ],
    });
    await alert.present();
  }

  async wrongTx(): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: 'Oops!',
      message: 'Algo salió mal, favor de intentarlo nuevamente.',
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
        },
      ],
    });
    await alert.present();
  }

  async getTicketInfo(data: { realtripId: number; stopId: number }) {
    await this.loadingService.present('Recuperando información...');
    return await this.apiService
      .getData(`realtrips/scan?realtrip_id=${data.realtripId}&stop_id=${data.stopId}`)
      .then((response) => {
        this.loadingService.dismiss();
        return response;
      })
      .catch(() => {
        this.wrongTx();
        this.loadingService.dismiss();
        return;
      });
  }

  async presentConfirmationDialog(data): Promise<boolean> {
    const { route_name, stop_name, stop2_name, price } = data;
    if (!route_name) {
      return false;
    }
    const alert = await this.alertCtrl.create({
      header: `Compra ${route_name}`,
      message: `¿Desea comprar boleto saliendo de ${stop_name} en dirección a ${stop2_name} con un costo de $${price}?`,
      buttons: [
        {
          text: 'No, cancelar',
          role: 'cancel',
        },
        {
          text: 'Sí, continuar',
          role: 'pay',
        },
      ],
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();
    if (role !== 'pay') {
      return false;
    }
    return true;
  }

  async payTicket(data): Promise<void> {
    await this.loadingService.present('Recuperando boleto...');
    this.apiService
      .postData('bustickets/scan', {
        realtrip_id: data.realtripId,
        stop_id: data.stopId,
        method: 'wallet',
        amount: data.price,
      })
      .then(() => {
        this.router.navigate(['tecservice-transportec/tickets']);
        this.loadingService.dismiss();
      })
      .catch(() => {
        this.wrongTx();
        this.loadingService.dismiss();
      });
  }

  presentOtherActionSheet() {
    this.helpService.deleteAccount();
  }
}
